export default __webpack_public_path__ + "static/media/NIAS0570.34I-40565_-23985_0.cd671688.jpg";